import React from 'react';

import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import type { GridRenderCellParams } from '@mui/x-data-grid-premium';

export const TypographyCell = (props: TypographyProps) => {
  const { children, sx: otherSx = {}, ...other } = props;
  return (
    <Typography className='MuiDataGrid-cellContent' sx={{ width: '100%', ...otherSx }} variant='inherit' {...other}>
      {children}
    </Typography>
  );
};

export const renderTypographyCell = (params: GridRenderCellParams) => {
  const { value } = params;
  return <TypographyCell>{value || '\u00A0'}</TypographyCell>;
};
